// @flow
export const capitalizeFirstLetter = (data: string = ''): string =>
  `${data.charAt(0).toUpperCase()}${data.slice(1)}`;
